import { render, staticRenderFns } from "./PermissionsGroupCardPage.vue?vue&type=template&id=7b2620d0"
import script from "./PermissionsGroupCardPage.vue?vue&type=script&lang=js"
export * from "./PermissionsGroupCardPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports